interface WaveSingleProps {
  diffHeight: number;
  heightTotal: number;
  bgColor: string;
}

export default function WaveSingle({
  diffHeight,
  heightTotal,
  bgColor,
}: WaveSingleProps) {
  return (
    <>
      <svg
        preserveAspectRatio="none"
        className="w-full"
        style={{ height: `${diffHeight}px` }}
        viewBox="0 0 151 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="0.0117188" width="37" height="33" fill={bgColor} />
        <path
          d="M36 0.0455907C36 0.0455907 49.7937 -0.640823 57.9444 4.16636C66.0952 8.97354 75.5 17.9022 75.5 17.9022C75.5 17.9022 83.4617 25.9404 91.1746 28.8906C98.8875 31.8409 115 33.0117 115 33.0117H36V0.0455907Z"
          fill={bgColor}
        />
      </svg>

      <svg
        className="w-full"
        style={{ height: `${heightTotal - diffHeight}px` }}
        preserveAspectRatio="none"
        viewBox="0 0 151 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="115" width="37" height="81" fill={bgColor} />
        <rect width="37" height="81" fill={bgColor} />
        <rect x="36" y="0.0126953" width="80" height="81" fill={bgColor} />
      </svg>
    </>
  );
}
